import { Component } from '@angular/core';

@Component({
  selector: 'ui-breadcrumb-item',
  templateUrl: './breadcrumb-item.component.html'
})
export class BreadcrumbItemComponent {

}